import React from 'react';
import { Card, CardContent, CircularProgress, Divider, Grid, IconButton, Skeleton, Typography } from '@mui/material';
import { Refresh } from '@mui/icons-material';
import CustomTextInput from '../CustomTextInput';
import { useSelector } from 'react-redux';

export default function PeppolDetails({
  control,
  errors,
  getValues,
  setParticipantId,
  handleFetchParticipants,
  loading,
  readOnly,
  loadingParticipant,
  isPeppolEmpty,
  peppolParticipant,
  peppolParticipantDescription,
  peppolLabels = {},
}) {
  const subscription = useSelector((state) => state.subscription.subscription);

  if (!subscription?.features?.enable_phase2) {
    return null;
  }

  return (
    <>
      <Typography variant="h6" sx={{ mb: '1.5rem', pt: '1rem' }}>
        {peppolLabels.peppol_details ?? 'Peppol Details'}
        <Divider />
      </Typography>

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <CustomTextInput
            name="participant_id"
            control={control}
            errors={errors}
            label={peppolLabels.participant_id ?? 'Participant ID'}
            onChange={() => setParticipantId(getValues('participant_id'))}
            readOnly={readOnly}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <IconButton onClick={handleFetchParticipants} color="success" disabled={loading || readOnly}>
            {loading ? <CircularProgress size={24} color="inherit" /> : <Refresh />}
          </IconButton>
        </Grid>
      </Grid>

      {loadingParticipant ? (
        <Card sx={{ mt: 4, p: 2 }}>
          <Skeleton variant="text" width="40%" height={30} />
          <Skeleton variant="text" width="60%" height={25} />
          <Skeleton variant="rectangular" width="100%" height={50} sx={{ mt: 2 }} />
        </Card>
      ) : (
        !isPeppolEmpty && (
          <Card sx={{ mt: 4 }}>
            <CardContent>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12 }}>
                  <Grid container spacing={2}>
                    <Grid size={{ xs: 6 }} display="flex" justifyContent="space-between">
                      <Typography variant="subtitle1" fontWeight="bold">
                        Scheme:
                      </Typography>
                      <Typography>{peppolParticipant.scheme}</Typography>
                    </Grid>
                    <Grid size={{ xs: 6 }} display="flex" justifyContent="space-between">
                      <Typography variant="subtitle1" fontWeight="bold">
                        Identifier Code:
                      </Typography>
                      <Typography>{peppolParticipant.identifier_code}</Typography>
                    </Grid>
                    <Grid size={{ xs: 6 }} display="flex" justifyContent="space-between">
                      <Typography variant="subtitle1" fontWeight="bold">
                        Special Identifier:
                      </Typography>
                      <Typography>{peppolParticipant.special_identifier}</Typography>
                    </Grid>
                    <Grid size={{ xs: 6 }} display="flex" justifyContent="space-between">
                      <Typography variant="subtitle1" fontWeight="bold">
                        Identifier:
                      </Typography>
                      <Typography>{peppolParticipant.identifier}</Typography>
                    </Grid>
                    <Grid size={{ xs: 6 }} display="flex" justifyContent="space-between">
                      <Typography variant="subtitle1" fontWeight="bold">
                        Endpoint ID:
                      </Typography>
                      <Typography>{peppolParticipant.endpoint_id}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        )
      )}
    </>
  );
}
